<template>
    <div>
      <p class="title has-text-centered">{{heading}}</p>

      <div class="columns" v-for="chunk in getChunked()" v-bind:key="chunk + Math.random()">
        <div class="column is-3 player-box" v-for="player in chunk" v-bind:key=player.id>
            <div  v-on:click="onClick(player.id)">
              <img class="team_logo image is-64x64 has-image-centered" :src='logo'>
              <p class="title  has-text-centered">#{{player.number}}</p>
              <p class="title has-text-centered">{{player.forename}} <br />{{player.surname}}</p>
            </div>
        </div>
      </div>
      <!--<div v-for="player in playerData" v-bind:key="player.id">
        <div class="columns is-centered">
          <div class="column is-half">
            <article class="box " v-on:click="onClick(player.id)">
              <img class="team_logo image is-96x96 has-image-centered" :src='logo'>
              <p class="title  has-text-centered">#{{player.number}}</p>
              <p class="title has-text-centered">{{player.forename}} {{player.surname}}</p>
            </article>
          </div>
        </div>
      </div> -->
    </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: ['headings', 'playerData', 'heading', 'redirect', 'logo'],
  methods: {
    onClick (id) {
      this.$router.push(this.redirect + id)
      this.$router.go()
    },
    test () {
      console.log(0)
      return 0
    },
    getChunked () {
      let chunk = _.chunk(this.playerData, 4)
      console.log(' Chunked: ' + JSON.stringify(chunk))
      return chunk
    }
  }
}
</script>

<style lang="scss" scoped>
.has-image-centered {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1em;
}
.title{
  font-family: 'Heebo', cursive;
  font-weight: 600;
  font-size: 1.5em;
}
.subtitle{
  font-family: 'Heebo', cursive;
  font-weight: 400;
  font-size: 1em;
}
.player-box {
    margin: .4em .2em;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
    display: block;
    padding: 1.25rem;
}
.player-box:hover {
  color:white;
  background-color:#722020db;
}
.player-box:hover p{
  color:white;
}
.columns:last-child {
    margin-bottom: 0 !important;
}
@media screen and (min-width: 769px) {
.column.is-3, .column.is-3-tablet {
  width: 24%;
}
}
</style>



// WEBPACK FOOTER //
// playerCard.vue?62b18994